import { ConnectorInfo } from '@blaze-shared/api-contracts-domain';
import { isApiCallNode, JoinWorkflowNode, Workflow } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('Join')
export class JoinNodeConnectorProvider extends ConnectorProvider<JoinWorkflowNode> {
  override getConnectors(
    workflow: Workflow,
    node: JoinWorkflowNode,
    connectors: ConnectorInfo[],
  ): ConnectorInfo[] {
    const nodeConnectors = super.getConnectors(workflow, node, connectors);
    const parentNode = workflow.nodes.find((n) => n.id === node.targetId);
    const parentNodeConnector = isApiCallNode(parentNode)
      ? connectors.find((c) => c.id === parentNode.connectorId)
      : null;

    if (parentNodeConnector) {
      nodeConnectors.push(parentNodeConnector);
    }

    return nodeConnectors;
  }
}
